import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
//import List from '@material-ui/core/List';
//import ListItem from '@material-ui/core/ListItem';
//import ListItemAvatar from '@material-ui/core/ListItemAvatar';
//import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
//import ListItemText from '@material-ui/core/ListItemText';

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Avatar from "@material-ui/core/Avatar";
import Checkbox from "@material-ui/core/Checkbox";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import DeleteIcon from "@material-ui/icons/Delete";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
//import ArrowForward from '@material-ui/icons/ArrowForward';
import Assignment from "@material-ui/icons/Assignment";
//import Divider from '@material-ui/core/Divider';
import { Redirect, useHistory } from "react-router-dom";

import { listByChannel, getChannelInfo } from "./api-video.js";
import { useVideoContext } from "../libs/contextLib";
//import config from '../config';

const useStyles = makeStyles((theme) => ({
  root: theme.mixins.gutters({
    width: "90%",
    margin: "auto",
    padding: theme.spacing(3),
    marginTop: theme.spacing(3),
  }),
  title: {
    margin: `${theme.spacing(3)}px 0 ${theme.spacing(3)}px ${theme.spacing(1)}px`,
    color: theme.palette.protectedTitle,
    fontSize: "1.2em",
  },
  tableRow: {
    "&:hover": {
      backgroundColor: "#49bb7b",
    },
  },
  avatar: theme.avatar,
}));

export default function MyChannels() {
  const history = useHistory();
  const classes = useStyles();
  const [channels, setChannels] = useState([]);
  const { state, dispatch } = useVideoContext();
  const [speaker, setSpeaker] = useState("original");
  const [dialogOpen, setDialogOpen] = useState(false);
  const [delChannel, setDelChannel] = useState(undefined);

  const getAllChannelInfo = async () => {
    const getChannelInfoPromises = state.serviceChannels.map((ch) => getChannelInfo(ch));
    let channelInfoList = [];
    await Promise.all(getChannelInfoPromises)
      .then((data) => {
        console.log("getAllChannelInfo promiseAll getChannelInfo data=", data);
        channelInfoList = data;
        console.log("channelInfoList=", channelInfoList);
        setChannels(channelInfoList);
        return channelInfoList;
      })
      .catch((error) => {
        console.log("Error during promiseAll:", error);
        return channelInfoList;
      });
  };

  useEffect(() => {
    const abortController = new AbortController();

    if (state.delaySpeakId) {
      clearTimeout(state.delaySpeakId);
      dispatch({ type: "setDelaySpeakId", payload: undefined });
    }
    console.log("MyChannels start state=", state);
    if (channels.length === 0) {
      getAllChannelInfo().then((data) => {
        console.log("useEffect getAllChannelInfo data=", data);
      });
    }
    return function cleanup() {
      abortController.abort();
    };
  }, []);

  const toVideoRow = (ch) => (event) => {
    dispatch({ type: "setChannel", payload: ch });
    const newSpeaker = ch.gender;
    console.log("newSpeaker=", newSpeaker);
    dispatch({ type: "setSpeaker", payload: newSpeaker });
    setSpeaker(newSpeaker);
    const newVoice = selectVoice(state.speech.voices, newSpeaker);
    dispatch({ type: "setVoice", payload: newVoice });

    history.push("/manage/videos/");
  };

  function selectVoice(voices, gender = null) {
    if (!voices || voices.length === 0) return;
    console.log(
      "voices given=",
      voices.map((vo) => ({ lang: vo.lang, voiceURI: vo.voiceURI }))
    );
    let sel1 = voices.filter((vo) => vo.voiceURI.trim().toLowerCase().includes("english"));
    if (gender) {
      sel1 = sel1.filter((vo) => vo.voiceURI.trim().toLowerCase().includes(gender));
      if (gender === "male") {
        sel1 = sel1.filter((vo) => !vo.voiceURI.trim().toLowerCase().includes("female"));
      }
    }
    if (!sel1 || sel1.lenght === 0) {
      return voices[0];
    }
    console.log("voice selected=", sel1);
    return sel1[0];
  }
  const onSelectVoice = (event) => {
    const newSpeaker = event.target.value;
    console.log("newSpeaker=", newSpeaker);
    dispatch({ type: "setSpeaker", payload: newSpeaker });
    setSpeaker(newSpeaker);
    const newVoice =
      newSpeaker === "original" ? null : selectVoice(state.speech.voices, newSpeaker);
    dispatch({ type: "setVoice", payload: newVoice });
    //setVoice(newVoice);
  };

  const clickDeleteButton = (delCh) => (event) => {
    event.stopPropagation();
    setDialogOpen(true);
    setDelChannel(delCh);
  };

  const deleteChannel = (event) => {
    console.log("deleteChannel event=", event);
    dispatch({ type: "deleteServiceChannel", payload: delChannel });
    const filteredChannels = channels.filter((ch) => ch.channelId !== delChannel.channelId);
    setChannels(filteredChannels);
    setDialogOpen(false);
  };
  const requestDialogClose = () => {
    setDialogOpen(false);
  };

  return (
    <div>
      <Paper className={classes.root} elevation={4}>
        <Typography type="title" className={classes.title}>
          Service Channel List
        </Typography>
        <Table style={{ tableLayout: "auto" }}>
          <TableHead>
            <TableRow>
              <TableCell>Channel</TableCell>
              <TableCell>Channel Title</TableCell>
              <TableCell>Start Date</TableCell>
              <TableCell align="right">Viewers Count</TableCell>
              <TableCell align="right">Videos Count</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {channels.map((ch) => {
              return (
                <TableRow
                  className={classes.tableRow}
                  hover
                  onClick={toVideoRow(ch)}
                  key={ch.channelId}
                >
                  <TableCell align="left">
                    <span style={{ alignItems: "center", display: "flex" }}>
                      <Avatar
                        variant="rounded"
                        className={classes.rounded, classes.avatar}
                        src={ch.thumbnailUrl}
                        style={{ marginRight: "10px" }}
                      >
                        <Assignment />
                      </Avatar>
                      {ch.channelSummary}
                    </span>
                  </TableCell>
                  <TableCell align="left">{ch.channelTitle}</TableCell>
                  <TableCell align="left">{ch.publishedAt}</TableCell>
                  <TableCell align="right">{ch.viewCount}</TableCell>
                  <TableCell align="right">{ch.videoCount}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
        {delChannel && (
          <Dialog open={dialogOpen} onClose={requestDialogClose}>
            <DialogTitle>{"Hide " + delChannel.channelTitle}</DialogTitle>
            <DialogContent>
              <DialogContentText>
                Confirm to Hide channel {`"${delChannel.channelTitle}"`}.
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={requestDialogClose} color="primary">
                Cancel
              </Button>
              <Button onClick={deleteChannel} color="secondary" autoFocus="autoFocus">
                Confirm
              </Button>
            </DialogActions>
          </Dialog>
        )}
        { /*
        <FormControl component="fieldset">
          <FormLabel component="legend">Speaker</FormLabel>
          <RadioGroup
            row
            aria-label="speaker"
            name="speaker1"
            value={speaker}
            onChange={onSelectVoice}
          >
            <FormControlLabel value="original" control={<Radio />} label="Original" />
            <FormControlLabel value="female" control={<Radio />} label="Female" />
            <FormControlLabel value="male" control={<Radio />} label="Male" />
          </RadioGroup>
        </FormControl>
        */}
      </Paper>
    </div>
  );
}
